import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ra-label-new',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './label-new.component.html',
  styleUrl: './label-new.component.css',
})
export class LabelNewComponent {}
